import { Create,TypeList,AddressList,Identity,GetModel,UpdateType,Finish,
  MyList,MyManagerList,MyWorkerList,
  SetWorker,Evaluation,Comment,WorkerList} from '@/assets/js/api/baoxiu'
const baoxiu = {
  state: {
    types:[],
    address:[],
    workers:[],
    manageTypes:[],
    identity:-1,
    items:[],
    baseItems:[
      {
        key:'title',
        value:'填写报修表单',
        show:true,
        validate:true
      },
      {
        key:'bxr',
        value:'报修人',
        show:true,
        validate:true
      },
      {
        key:'lxdh',
        value:'联系电话',
        show:true,
        validate:true
      },
      {
        key:'yysj',
        value:'预约时间',
        show:true,
        validate:true
      },
      {
        key:'gzlx',
        value:'故障类型',
        show:true,
        validate:true
      },
      {
        key:'xqld',
        value:'校区楼栋',
        show:true,
        validate:true
      },
      {
        key:'xxdz',
        value:'详情地址',
        show:true,
        validate:true
      },
      {
        key:'gzyy',
        value:'故障原因',
        show:true,
        validate:true
      },
      {
        key:'scgztp',
        value:'上传故障图片',
        show:true,
        validate:true
      },
      {
        key:'finish_images',
        value:'上传完工图片',
        show:true,
        validate:true
      },
      {
        key:'finish_explain',
        value:'完工说明',
        show:true,
        validate:false
      },
      {
        key:'bottom_explain',
        value:'低部说明文字',
        show:false,
        validate:false
      }
    ]
  },
  actions: {
    loadData ({ commit },data) {
      let params = {base_type:data.base_type}
      TypeList(params).then(res => {
        commit('SET_TYPES', res.data.data)
      })
      WorkerList(params).then(res => {
        commit('SET_WORKERS', res.data.data)
      })
      Identity(params).then(res => {
        commit('SET_IDENTITY', res.data.data)
      })
      AddressList( {base_type:data.base_type,parent_guid:''}).then(res => {
        commit('SET_ADDRESS', res.data.data)
      })
    },
    create ({ commit },params) {
      return new Promise((resolve, reject) => {
        Create(params).then(res => {
          resolve(res.data)
        })
      })
    },
    myList ({ commit },params) {
      return new Promise((resolve, reject) => {
        MyList(params).then(res => {
          resolve(res.data)
        })
      })
    },
    myManagerList ({ commit },params) {
      return new Promise((resolve, reject) => {
        MyManagerList(params).then(res => {
          resolve(res.data)
        })
      })
    },
    myWorkerList ({ commit },params) {
      return new Promise((resolve, reject) => {
        MyWorkerList(params).then(res => {
          resolve(res.data)
        })
      })
    },
    getModel ({ commit },params) {
      return new Promise((resolve, reject) => {
        GetModel(params).then(res => {
          resolve(res.data)
        })
      })
    },
    finish ({ commit },params) {
      return new Promise((resolve, reject) => {
        Finish(params).then(res => {
          resolve(res.data)
        })
      })
    },
    setWorker ({ commit },params) {
      return new Promise((resolve, reject) => {
        SetWorker(params).then(res => {
          resolve(res.data)
        })
      })
    },
    evaluation ({ commit },params) {
      return new Promise((resolve, reject) => {
        Evaluation(params).then(res => {
          resolve(res.data)
        })
      })
    },
    comment ({ commit },params) {
      return new Promise((resolve, reject) => {
        Comment(params).then(res => {
          resolve(res.data)
        })
      })
    },
    updateType ({ commit },params) {
      return new Promise((resolve, reject) => {
        UpdateType(params).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  mutations: {
    SET_TYPES(state, datas) {
      if(datas.length == 0){
        state.types =  [[{name:'',value:'empty'}]]
      }else{
        datas.map(m=>{
          m.value = m.guid
        })
        state.types =  [datas]
      }
    },
    SET_ADDRESS(state, datas) {
      state.address =  datas
    },
    SET_WORKERS(state, datas) {
      if(datas.length == 0){
        state.workers =  [[{name:'',value:'empty'}]]
      }else{
        datas.map(m=>{
          m.value = m.guid
        })
        state.workers =  [datas]
      }
    },
    SET_IDENTITY(state, data) {
      state.manageTypes = data.manageTypes
      state.identity =  data.identity
    },
    SET_ITEMS(state,base_type){
      state.items = JSON.parse(JSON.stringify(state.baseItems))
      if(base_type == "xitong"){
        state.items.map(a=>{
          if(a.key == 'yysj' || a.key == 'xqld' || a.key == 'xxdz' || a.key == 'gztp' || a.key == 'scgztp' || a.key== 'finish_images'){
            a.show = false
            a.validate = false
          }else if(a.key == "title"){
            a.value = "请填写申请表"
          }else if(a.key == "bxr"){
            a.value = "申请人"
          }else if(a.key == "gzlx"){
            a.value = '问题类型'
          }else if(a.key == "gzyy"){
            a.value = '问题描述'
          }else if(a.key == "finish_explain"){
            a.validate = true
          }else if(a.key == "bottom_explain"){
            a.show = true
          }
        })
      }
    }
  },
  namespaced: true
}

export default baoxiu;



// WEBPACK FOOTER //
// ./src/store/modules/baoxiu.js